(function () {
function isShopSliderMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
}

function isShopSliderTablet() {
    return window.matchMedia('(max-width: 1200px)').matches;
}

function getShopSliderBreakpoint() {
    if (isShopSliderMobile()) {
        return 'mobile';
    }

    if (isShopSliderTablet()) {
        return 'tablet';
    }

    return 'desktop';
}

function getShopSliderPerPage() {
    const breakpoint = getShopSliderBreakpoint();

    if (breakpoint === 'mobile') {
        return 1;
    }

    if (breakpoint === 'tablet') {
        return 2;
    }

    return 3;
}

function getShopSliderGap() {
    if (isShopSliderMobile()) {
        return '14px';
    }

    if (isShopSliderTablet()) {
        return '16px';
    }

    return '15px';
}

function getShopSliderSplideOptions() {
    const perPage = getShopSliderPerPage();

    return {
        type: 'slide',
        perPage,
        perMove: perPage,
        gap: getShopSliderGap(),
        autoHeight: false,
        height: 'auto',
        pagination: false,
        arrows: false,
        drag: true,
        snap: true,
        focus: 0,
        trimSpace: true,
        updateOnMove: true,
        padding: {
            left: 0,
            right: 0,
        },
    };
}

function getShopSliderDotCount(slideCount) {
    const perPage = getShopSliderPerPage();
    return Math.max(1, Math.ceil(slideCount / perPage));
}

function getShopSliderDotIndex(slideIndex) {
    const perPage = getShopSliderPerPage();
    return Math.floor(slideIndex / perPage);
}

function getShopSliderSlideIndexFromDot(dotIndex) {
    return dotIndex * getShopSliderPerPage();
}

function removeShopSliderPagination(root) {
    root.querySelectorAll('.splide__pagination').forEach((pagination) => {
        pagination.remove();
    });
}

function initShopProductsSlider(root) {
    if (typeof Splide === 'undefined') {
        return;
    }

    const section = root.closest('.shop-products-slider');
    const prevBtn = section?.querySelector('[data-shop-products-slider-prev]');
    const nextBtn = section?.querySelector('[data-shop-products-slider-next]');
    const dotsRoot = section?.querySelector('[data-shop-products-slider-dots]');
    const slideCount = Number(
        dotsRoot?.getAttribute('data-shop-products-slider-slide-count')
        || root.getAttribute('data-shop-products-slider-count')
        || root.querySelectorAll('.splide__slide').length
    );
    let splide = null;
    let breakpoint = getShopSliderBreakpoint();
    let resizeTimer = null;

    const renderDots = () => {
        if (!dotsRoot) {
            return;
        }

        const dotCount = getShopSliderDotCount(slideCount);
        dotsRoot.innerHTML = '';

        if (dotCount <= 1) {
            dotsRoot.hidden = true;
            return;
        }

        dotsRoot.hidden = false;

        for (let index = 0; index < dotCount; index += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = `shop-products-slider__dot${index === 0 ? ' is-active' : ''}`;
            dot.setAttribute('data-shop-products-slider-dot', String(index));
            dot.setAttribute('aria-label', `Rodyti produktus ${index + 1}`);
            dot.setAttribute('aria-current', index === 0 ? 'true' : 'false');
            dotsRoot.appendChild(dot);
        }
    };

    const getDots = () => section?.querySelectorAll('[data-shop-products-slider-dot]') ?? [];

    const updateDots = (index) => {
        const activeDot = getShopSliderDotIndex(index);

        getDots().forEach((dot) => {
            const dotIndex = Number(dot.getAttribute('data-shop-products-slider-dot'));
            const isActive = dotIndex === activeDot;

            dot.classList.toggle('is-active', isActive);
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
    };

    const updateNavButtons = () => {
        if (!splide || !prevBtn || !nextBtn) {
            prevBtn?.removeAttribute('disabled');
            nextBtn?.removeAttribute('disabled');
            return;
        }

        prevBtn.disabled = splide.index === 0;
        nextBtn.disabled = splide.index >= splide.Components.Controller.getEnd();
    };

    const bindDotControls = () => {
        if (!splide) {
            return;
        }

        getDots().forEach((dot) => {
            dot.addEventListener('click', () => {
                const dotIndex = Number(dot.getAttribute('data-shop-products-slider-dot'));
                splide.go(getShopSliderSlideIndexFromDot(dotIndex));
            });
        });
    };

    const bindNavControls = () => {
        if (!prevBtn || !nextBtn || prevBtn.dataset.shopSliderBound === 'true') {
            return;
        }

        prevBtn.addEventListener('click', () => {
            splide?.go('<');
        });
        nextBtn.addEventListener('click', () => {
            splide?.go('>');
        });

        prevBtn.dataset.shopSliderBound = 'true';
        nextBtn.dataset.shopSliderBound = 'true';
    };

    const mountSlider = ({ preserveIndex = false } = {}) => {
        const targetIndex = preserveIndex && splide ? splide.index : 0;

        if (splide) {
            splide.destroy(true);
            splide = null;
        }

        renderDots();
        removeShopSliderPagination(root);

        splide = new Splide(root, getShopSliderSplideOptions());

        splide.on('mounted', () => {
            removeShopSliderPagination(root);
            bindDotControls();

            if (preserveIndex && targetIndex > 0) {
                splide.go(Math.min(targetIndex, splide.Components.Controller.getEnd()));
            }

            updateDots(splide.index);
            updateNavButtons();
        });

        splide.on('move', (index) => {
            updateDots(index);
            updateNavButtons();
        });

        splide.on('resized', updateNavButtons);

        splide.mount();
    };

    bindNavControls();
    mountSlider();

    const handleResize = () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(() => {
            const nextBreakpoint = getShopSliderBreakpoint();

            if (nextBreakpoint !== breakpoint) {
                breakpoint = nextBreakpoint;
                mountSlider({ preserveIndex: true });
                return;
            }

            if (!splide) {
                return;
            }

            splide.options = getShopSliderSplideOptions();
            splide.refresh();
            updateDots(splide.index);
            updateNavButtons();
        }, 200);
    };

    window.addEventListener('resize', handleResize);

    const mobileMq = window.matchMedia('(max-width: 768px)');
    const tabletMq = window.matchMedia('(max-width: 1200px)');
    const onMediaChange = () => handleResize();

    if (typeof mobileMq.addEventListener === 'function') {
        mobileMq.addEventListener('change', onMediaChange);
        tabletMq.addEventListener('change', onMediaChange);
    } else {
        mobileMq.addListener(onMediaChange);
        tabletMq.addListener(onMediaChange);
    }
}

document.querySelectorAll('[data-shop-products-slider]').forEach(initShopProductsSlider);

})();
